import Logo from "./Logo";

export default function Masthead({ title, subtitle }) {
  return (
    <header className="masthead">
      <div className="wordmark-row">
        <Logo className="wordmark-logo" size={32} />
        <div className="wordmark">{title}</div>
      </div>
      {subtitle && <div className="sub">{subtitle}</div>}
    </header>
  );
}
